import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Badge } from '@ovComponents/2-component/badge/badge';
import { LinearProgress } from '@ovComponents/2-component/linearProgress/linearProgress';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { BORDERED_BOX_SX, SECONDARY_TEXT_SX } from '../styles';

export type OperationRowProps = {
  badgeLabel: string;
  badgeColor: 'warning' | 'neutral';
  title: string;
  progress: number;
  stateLabel: string;
  elapsed: number;
  accentColor?: string;
  progressBarColor?: 'info';
};

const OperationRow = ({
  badgeLabel,
  badgeColor,
  title,
  progress,
  stateLabel,
  elapsed,
  accentColor,
  progressBarColor,
}: OperationRowProps) => {
  const { sys } = useThemeTokens();

  return (
    <Box
      sx={{
        mb: 1,
        p: 1,
        ...BORDERED_BOX_SX,
        borderLeft: '3px solid',
        borderLeftColor: accentColor,
      }}
    >
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        mb={0.25}
      >
        <Box display='flex' alignItems='center' gap={0.75}>
          <Badge label={badgeLabel} color={badgeColor} />
          <Typography variant='labelSmall' sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <Typography variant='labelSmall' sx={SECONDARY_TEXT_SX}>
          {elapsed}m ago
        </Typography>
      </Box>
      <Box display='flex' alignItems='center' gap={1}>
        <Box flex={1}>
          <LinearProgress
            variant='determinate'
            value={progress}
            sx={
              progressBarColor === 'info'
                ? {
                    height: 3,
                    borderRadius: 2,
                    '& .MuiLinearProgress-bar': { bgcolor: sys.color.primary },
                  }
                : { height: 3, borderRadius: 2 }
            }
          />
        </Box>
        <Typography
          variant='labelSmall'
          sx={{ fontWeight: 600, minWidth: 80, textAlign: 'right' }}
        >
          {stateLabel}
        </Typography>
      </Box>
    </Box>
  );
};

export default OperationRow;
